export default __webpack_public_path__ + "static/media/CapaConnect.16c66dac.svg";